import Utils from "../services/utils-service.js";
import RV from "../services/rv-service.js";
import Funnel from "../services/funnel-service.js";
import router from "../router.js";
import { throwError } from "../errors.js";

export default {
    state: {
        rvYmmb: ['year', 'make', 'model', 'bodystyle'], //ymmb waterfall executes in order from index 0-3
        rvYmmbCtrl: []
    },
    getters: {
        rvYmmb: state => state.rvYmmb,
        rvYmmbCtrl: state => state.rvYmmbCtrl
    },
    mutations: {
        setRvYmmb(state, rvYmmb) {
            state.rvYmmb = rvYmmb;
        },
        resetRvYmmbCtrl(state) {
            state.rvYmmbCtrl = [];
        },
        addRvYmmbCtrl(state, rvYmmbCtrl) {
            for (const f of rvYmmbCtrl.split(',')) {
                state.rvYmmbCtrl.push(f);
            }
        }
    },
    actions: {
        processRVDiscovery(context, data) {
            const uid = data.rsrc != 'nada_id' ? `in_${data.rsrc}` : 'in_bodystyle';

            $.ajax({
                type: 'POST',
                url: '/api?req=recv&action=rv-discovery',
                data: data,
                beforeSend: function () {
                    if (context.getters.rvYmmb.indexOf(data.rsrc) != -1 || data.rsrc == 'nada_id') {
                        context.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: true });
                    }
                },
                success: function (res) {
                    console.log('RV discovery result: ', res);
                    //TODO: Add error response for empty arrary response.
                    if (context.getters.rvYmmb.indexOf(data.rsrc) != -1 || data.rsrc == 'nada_id') {
                        context.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: false });
                    }

                    const rv = new RV({ ctx: context });

                    if (res != null && Object.keys(res).length > 0) {

                        rv.resetRvFieldAndOptions({ req: data, res: res });

                        const iuid = rv.rvPropStr(data.rsrc);

                        if (context.getters.funnel.elements[iuid] && !Utils.isEmpty(context.getters.funnel.elements[iuid].value)) {
                            rv.rvDiscovery(data.rsrc, data.veh);
                        }
                        if (data.rsrc == 'nada_id') {
                            rv.setRvDetail(res);
                        }
                    }
                },
                error: function () { }
            });
        }
    }
}